import { Components } from '@mui/material/styles';

// ----------------------------------------------------------------------

export function checkbox(): Components {
  return {
    MuiCheckbox: {
      styleOverrides: {
        root: {
          padding: '0px !important',
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          marginRight: '5px',
          marginLeft: '0px',
        },
      },
    },
  };
}
